import { __awaiter, __decorate } from "tslib";
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import Injector, { InjectorScope } from '@slickdeals/durango/dist/javascript/core/injector';
import Modal from '@slickdeals/blueprint-twig/javascript/components/modal';
import Redirector from '@slickdeals/durango/dist/javascript/utilities/redirector';
/* eslint-disable import/extensions */
import { name as CashbackActivatorModalContextServiceName } from './cashbackActivatorModalContextService';
import { name as CashbackActivatorInterstitialContextServiceName } from '../cashbackActivatorInterstitial/cashbackActivatorInterstitialContextService';
import { ClassNames as CashbackWelcomeModalClassNames } from './_cashbackWelcomeModal';
import { ClassNames as CashbackInterstitialFailureClassNames, DataRoleNames as CashbackInterstitialFailureDataRoleNames } from '../cashbackActivatorInterstitial/_cashbackInterstitialFailure';
/** Import styles for all modal states */
import '../../../scss/patterns/cashbackActivatorModal/cashbackWelcomeModal.scss';
import '../../../scss/patterns/cashbackActivatorInterstitial/cashbackInterstitialSuccess.scss';
import '../../../scss/patterns/cashbackActivatorInterstitial/cashbackInterstitialFailure.scss';
export const name = 'CashbackActivatorModal';
// Import both modal types as dependencies
export const dependencies = Object.assign(Object.assign({}, Injector.createDependency(CashbackActivatorModalContextServiceName, InjectorScope.Factory)), Injector.createDependency(CashbackActivatorInterstitialContextServiceName, InjectorScope.Factory));
let CashbackActivatorModal = class CashbackActivatorModal {
    constructor(modalService, interstitialService) {
        this.modalService = modalService;
        this.interstitialService = interstitialService;
    }
    /**
     * Initializes welcome modal
     * @param data Data being passed from backend
     * @param heap Heap instance used to fire impressions
     */
    initModal(data, heap) {
        return __awaiter(this, void 0, void 0, function* () {
            this.data = data;
            this.heap = heap;
            const modalContent = this.modalService.initModalContext(this.heap);
            this.modal = new Modal({
                content: modalContent,
                isFixed: true,
                closeButton: true,
            });
            /** Set up secondary button within modal */
            const secondaryButton = modalContent.querySelector(`.${CashbackWelcomeModalClassNames.SecondaryButton}`);
            secondaryButton.setAttribute('data-role', 'returnToDealDetailsFromModal');
            secondaryButton.addEventListener('click', this.closeModal.bind(this));
            /** Set up primary button within modal */
            const primaryButton = modalContent.querySelector(`.${CashbackWelcomeModalClassNames.PrimaryButton}`);
            primaryButton.setAttribute('data-role', 'goGetThisDeal');
            primaryButton.addEventListener('click', yield this.triggerInterstitial.bind(this));
            /** Trigger rewards w/o ext interstitials on see deal button click */
            const seeDealCtaForLoyalty = document.querySelector('[data-show-loyalty-outclick-flow]');
            if (seeDealCtaForLoyalty) {
                seeDealCtaForLoyalty.addEventListener('click', e => {
                    e.preventDefault();
                    this.triggerInterstitial();
                });
            }
        });
    }
    /**
     * Triggers the interstitial modal that shows failure or success state
     */
    triggerInterstitial() {
        return __awaiter(this, void 0, void 0, function* () {
            /** Inner content for interstitial modal */
            this.interstitialModalContent = yield this.interstitialService.initInterstitialModalContext(this.data, this.heap);
            /** Create new modal instance with inner ui for interstitial */
            this.interstitialModal = new Modal({
                content: this.interstitialModalContent,
                isFixed: true,
                closeButton: false,
            });
            // Close main welcome modal
            this.closeModal();
            // NOTE: Commented out while we figure out how to proceed with Product/Design.
            // document.addEventListener('hideSuccessEventModal', () => { this.interstitialModal.hide(); });
            // Open interstitial modal
            this.interstitialModal.show(true);
            this.configureButtons();
            /** Set up reference to style block */
            this.overrideStyleBlock = document.getElementById('styleBlockOverride');
        });
    }
    /** Show main welcome modal */
    showModal() {
        this.modal.show(true);
        this.modalService.fireHeapEvent();
    }
    /** Hide main welcome modal */
    closeModal() {
        this.modal.hide();
    }
    /**
     * Hides interstitial modal and removes style block from DOM tree
    */
    closeInterstitialModal() {
        this.interstitialModal.hide();
        // Remove modal component container overriding styles from DOM tree
        this.overrideStyleBlock.remove();
    }
    /**
     * Sets up the primary and secondary button for failure state interstitial
     */
    configureButtons() {
        /** Set up close button on failure interstitial */
        const closeButton = this.interstitialModalContent.querySelector(`.${CashbackInterstitialFailureClassNames.ReturnButton}`);
        if (closeButton) {
            closeButton.setAttribute('data-role', CashbackInterstitialFailureDataRoleNames.CloseButton);
            closeButton.addEventListener('click', this.closeInterstitialModal.bind(this));
        }
        /** Set up proceed button */
        const proceedButton = this.interstitialModalContent.querySelector(`.${CashbackInterstitialFailureClassNames.ProceedLink}`);
        if (proceedButton) {
            proceedButton.setAttribute('data-role', CashbackInterstitialFailureDataRoleNames.ProceedButton);
            proceedButton.addEventListener('click', () => {
                Redirector.open(proceedButton.dataset.href);
                this.interstitialModal.hide();
            });
        }
    }
};
CashbackActivatorModal = __decorate([
    injectable(name, dependencies)
], CashbackActivatorModal);
export default CashbackActivatorModal;
